/**
 * @generated SignedSource<<ebaf6240e7656ac8f712b17972fca837>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sessionLoaderQuery$variables = {
  id: string;
};
export type sessionLoaderQuery$data = {
  readonly session: {
    readonly id: string;
    readonly sessionId?: string;
  };
};
export type sessionLoaderQuery = {
  response: sessionLoaderQuery$data;
  variables: sessionLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    }
  ],
  "type": "ProjectSession",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sessionLoaderQuery",
    "selections": [
      {
        "alias": "session",
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sessionLoaderQuery",
    "selections": [
      {
        "alias": "session",
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e24902c01f282294437ffeec0084a2af",
    "id": null,
    "metadata": {},
    "name": "sessionLoaderQuery",
    "operationKind": "query",
    "text": "query sessionLoaderQuery(\n  $id: ID!\n) {\n  session: node(id: $id) {\n    __typename\n    id\n    ... on ProjectSession {\n      sessionId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ddb30651beeea59f8543ce916b705810";

export default node;
